






























































































































































import { Component, Prop } from 'vue-property-decorator';
import JdsLocation from "@/design-system/components/JdsLocation.vue"
import JdsTimestamp from "@/design-system/components/Timestamp/JdsTimestamp.vue"
import JdsAvatarStack from '@/design-system/constructs/Avatar/JdsAvatarStack.vue';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import moment from 'moment';
import {mixins} from "vue-class-component"
import TextProviderMixin from "@/design-system/utilities/TextProviderMixin"
import { Job, JobCampaignStatus, JobStatus } from '@/design-system/constructs/JobTile/JobTileViewModel';

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 5.5.0 Introduced data model and mail count badge.
 * @changelog 5.5.1 Updated data model to reflect Jobilla API output.
 * @changelog 6.2.0 Added job favoriting functionality.
 * @changelog 6.3.0 Added job status and unlisted status.
 * @changelog 6.4.3 Added job assignees avatars.
 */
@Component({
    components: {
        JdsAvatarStack, JdsGlyph, JdsIcon, JdsTimestamp, JdsLocation
    }
})
export default class JdsJobTile extends mixins(TextProviderMixin) {
    @Prop({ required: true }) job!: Job;
    @Prop({ default: null }) to!: Location | null;
    @Prop({ default: false }) allowFavoriting!: boolean;

    get progressBar() {
        if (!this.job.activeFrom || !this.job.activeTo) return 0;

        return (((moment().diff(this.job.activeFrom)) / (moment(this.job.activeTo).diff(this.job.activeFrom))) * 100) + '%';
    }

    get totalCandidates() {
        if (!this.job.pipeline) {
            return 0;
        }

        return Object.values(this.job.pipeline).reduce((a, b) => a + b, 0);
    }

    get expired() {
        return moment().isAfter(this.job.activeTo);
    }

    get fresh() {
        return false;
    }

    get jobStatus() {
        return JobStatus;
    }

    get campaignStatus() {
        return JobCampaignStatus;
    }

    get isValidJobStatus() {
        return this.job.status && Object.values(JobStatus).includes(this.job.status);
    }

    get iconForJobStatus () {
        return {
            draft: 'draft',
            open: 'open-to-candidates',
            processing: 'processing-candidates',
            completed: 'completed',
        }
    };
}
